module.exports = __webpack_public_path__ + "img/9.3f2e0335.jpg";